<script setup lang="ts">
import CaseData from './CaseData.vue'
</script>

<template>
  <div class="flex flex-row overflow-auto bg-surface-primary">
    <CaseData class="size-full grow overflow-auto" />
  </div>
</template>
